import { Hole } from '../../objects/index.js';

/**
 * Checks if a node is a Hole object.
 */
export const isHole = (node: unknown): node is Hole => {
  return !!(node && (node as Hole).isHole);
};
